import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCountry } from 'API/Country/updateCountry';

const useUpdateCountry = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async (countryData) => {
        const response = await updateCountry(countryData);
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['Countries'] });
            queryClient.invalidateQueries({
                queryKey: ['Country', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateCountry;
